import React from 'react';
import { NotFoundError } from '../../../errors/not-found-error';
import { useAsset } from '../../../queries/ats/titles/hooks';
import { DetailsContextProvider } from '../details-context';
import { DetailsSkeleton } from '../details-skeleton/details-skeleton';
import { DetailsView } from '../details-view/details-view';
import { useDetailsSearchParams } from '../use-details-search-params';
import { DetailsViewLoaderProps } from './details-view-loader';
import { DetailsViewWrapper } from './details-view-wrapper';

export function DefaultDetailsViewLoader({
  id,
  orderByProviderId,
  orderByServiceType,
  before,
  after,
}: Omit<DetailsViewLoaderProps, 'type'>) {
  const { includeExpired } = useDetailsSearchParams();

  const { data: asset, isLoading } = useAsset({
    id,
    orderByProviderId,
    orderByServiceType,
    includeExpired,
  });

  if (isLoading) {
    return (
      <DetailsViewWrapper asset={undefined} before={before} after={after}>
        <DetailsSkeleton />
      </DetailsViewWrapper>
    );
  }

  if (asset === undefined) {
    throw new NotFoundError(id);
  }

  return (
    <DetailsViewWrapper asset={asset} before={before} after={after}>
      <DetailsContextProvider asset={asset}>
        <DetailsView asset={asset} />
      </DetailsContextProvider>
    </DetailsViewWrapper>
  );
}
